import React from 'react';
import { Link } from 'react-router-dom';  // Add this import
import Lottie from 'react-lottie';
import '../../styles/ServiceCard.css';

const ServiceCard = ({ title, description, features, animation, animationType, route }) => {
    // Default options for Lottie animation
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <Link to={route} className="service-card-link">  {/* Wrap with Link */}
            <div className="service-card">
                <div className="service-animation">
                    {animationType === 'lottie' ? (
                        <Lottie options={defaultOptions} height={200} width={200} />
                    ) : (
                        <div className="service-image-container">
                            <img 
                                src={animation} 
                                alt={title} 
                                className="service-image" 
                            />
                        </div>
                    )}
                </div>
                <h3>{title}</h3>
                <p>{description}</p>
                
                {/* Features list */}
                <ul className="service-features">
                    {features.map((feature, index) => (
                        <li key={index}>{feature}</li>
                    ))}
                </ul>
                
                <button className="learn-more-btn">Learn More</button>
            </div>
        </Link>
    );
};

export default ServiceCard;